'use client';

import { useRouter } from 'next/navigation';

import { LegacyIcon, LegacyIconName, useAuthSignInClick, useUserSession } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';

export default function LegacyHeaderPersonIcon() {
    const router = useRouter();
    const { user } = useUserSession();
    const { handleSignInClick } = useAuthSignInClick();

    const handleClickPersonIcon = () => {
        if (user) {
            return router.push(NAVIGATION_URLS.velocity.account.aboutYou);
        }

        handleSignInClick();
    };

    return (
        <button
            type="button"
            onClick={handleClickPersonIcon}
            title="Rewards & Account"
            data-testid="legacy-header-account-link"
            className="legacy-header__person"
        >
            <LegacyIcon aria-hidden="true" name={LegacyIconName.PERSON} isPriority size={20} />
        </button>
    );
}
